module.exports = __webpack_public_path__ + "img/punga-thumb.c9978554.jpg";